import { PapiAttachmentFile, PapiDeviation } from '@wix/da-papi-types';
import { useMemo } from 'react';

/** Sorts additionalMedia by position, memoizes, and always returns an array */
export function useAdditionalMedia(
  deviation: PapiDeviation
): PapiAttachmentFile[] {
  return useMemo(() => {
    const additionalMedia = deviation.extended?.additionalMedia;
    if (!additionalMedia) {
      return [];
    }

    const sorted = additionalMedia.sort((a, b) => {
      return (a.position ?? 0) - (b.position ?? 0);
    });
    return sorted;
  }, [deviation.extended?.additionalMedia]);
}
